import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import InfluencerIdentityRowLabelTooltip from '@components/InfluencerIdentity/Row/LabelTooltip'
import InfluencerIdentityRowValueAndLabel from '@components/InfluencerIdentity/Row/ValueAndLabel'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId/Provider'
import { IApplicationState } from '@store'
import { selectInfluencerIdentityAverageEngagementPercent } from '@store/influencerIdentities'
import { selectCampaignId } from '@store/router'

const InfluencerIdentityRowPerformanceAverageEngagement = () => {
  const match = useRouteMatch()

  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const { engagement } = useSelector((state: IApplicationState) => {
    const campaignId = selectCampaignId(match)!
    return {
      engagement: selectInfluencerIdentityAverageEngagementPercent(
        state,
        campaignId,
        contextInfluencerIdentityId,
      ),
    }
  }, shallowEqual)

  return (
    <InfluencerIdentityRowValueAndLabel
      value={
        engagement ? (
          <FormattedMessage id="core.text.percent" values={{ value: engagement }} />
        ) : (
          <FormattedMessage id="core.metric.empty" />
        )
      }
      label={
        <InfluencerIdentityRowLabelTooltip
          width={15.25}
          title={<FormattedMessage id="submission.performance.averageEngagement.title" />}
          body={<FormattedMessage id="submission.performance.averageEngagement.body" />}
        >
          <FormattedMessage id="submission.performance.averageEngagement" />
        </InfluencerIdentityRowLabelTooltip>
      }
    />
  )
}

export default InfluencerIdentityRowPerformanceAverageEngagement
